/* unplugin-vue-components disabled */import script from "./agreement.vue?vue&type=script&lang=ts&setup=true"
export * from "./agreement.vue?vue&type=script&lang=ts&setup=true"

import "./agreement.vue?vue&type=style&index=0&id=16647c99&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16647c99"]])

export default __exports__